import { render, staticRenderFns } from "./InfoFormComponent.vue?vue&type=template&id=190e2792"
import script from "./InfoFormComponent.vue?vue&type=script&lang=js"
export * from "./InfoFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports